module.exports = __webpack_public_path__ + "img/H2.853c0f98.png";